exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loginPage .loginImgSection{text-align:center}.loginPage .loginImgSection .wiseOwlsImg{width:240px;margin:0 auto;margin-bottom:5px}.loginPage .loginLinks{display:inline-block;vertical-align:top}.loginPage .buttonPrimary{position:absolute;right:16px}.loginPage .googleBtn{width:100%}.loginPage .googleBtn img{width:40px;position:relative;right:11px}.loginPage .g-signin2-alt{cursor:pointer;position:absolute;opacity:0;width:100%;height:48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/logins/login_page.scss
// module id = 857
// module chunks = 0